<template>
  <el-dialog
    title="Pagar Comissão Completa"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    width="30%"
    v-loading="loading"
  >
    <el-form size="small" label-position="top">
      <el-form-item label="Corretor" style="width: 100%">
        <el-input
          v-if="!comissao.comissaoImobiliaria"
          v-model="comissao.corretor.nome"
          style="width: 100%"
          readonly
        ></el-input>

        <el-input value="IMOBILIÁRIA" v-else readonly></el-input>
      </el-form-item>

      <el-row :span="24" :gutter="4">
      <el-col :span="12">
        <el-form-item label="Data de Pagamento">
          <el-date-picker
            v-model="dataPagamento"
            v-mask="'##/##/####'"
            type="date"
            format="dd/MM/yyyy"
            value-format="dd/MM/yyyy"
            style="width: 100%"
          />  
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="Valor">
          <el-input v-model="comissao.valorEmAberto" readonly></el-input>
        </el-form-item>
      </el-col>
      </el-row>
       <el-row :gutter="10" style="align-items: center">
        <el-col :span="10">
          <el-form-item label="Conta para Depósito" style="width: 225%">
            <el-input size="small" v-model="labelContaParaDeposito" disabled style="float: right"></el-input>
          </el-form-item>
        </el-col>
        <div style="float: right">
          <el-col :span="2">
          <el-button @click="exibirSelecionarContaBancariaDestinoDialog()" type="primary" icon="el-icon-search" size="small" style=" margin-top: 17px;" circle class="btn-box-shadow"/>
        </el-col>
        </div>
      </el-row>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="pagarComissao" type="success" round class="btn-box-shadow">Pagar</el-button>
    </span>

    <app-selecionar-conta-bancaria-dialog @close="fecharSelecionarContaBancariaDestinoDialog" :usuario="comissao.corretor" :visibility="visibilidadeSelecionarContaBancariaDestinoDialog" todosOsBancos/>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Util from "../../../util/funcoes.js";
import AppSelecionarContaBancariaDialog from '../../../shared/dialogs/SelecionarContaBancariaDialog.vue';
import {BANCOS } from '../../../util/constantes.js';


export default {
   components: {
    AppSelecionarContaBancariaDialog,
  },

  props: {
    visibility: Boolean,
    comissao: {
      corretor: {
        nome: ''
      }
    }
  },
  data() {
    return {
      dataPagamento: Util.hoje(),
      pagamentoComissao: {},

      visibilidadeSelecionarContaBancariaDestinoDialog: false,

      contaBancaria: {
        id: 0,
        nome: ''
      },
    };
  },
  computed: {
    ...mapState("vendasContratosStore", {
      venda(state) {
        return state.vendaSelecionada;
      },
      usuariosDisponiveis() {
        return this.$store.state.vendasContratosStore.usuariosDisponiveis;
      }
    }),
    loading() {
      return this.$store.state.loading;
    },
    labelContaParaDeposito(){
      return `${Util.getLabel(BANCOS, this.contaBancaria.banco) ? Util.getLabel(BANCOS, this.contaBancaria.banco) : ''} ${this.contaBancaria.conta ? ' - Conta: ' + this.contaBancaria.conta : ''}${this.contaBancaria.digitoConta ? '-' + this.contaBancaria.digitoConta : ''}`
    }
    
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasContratosStore", ["pagarComissaoCompleta"]),
    pagarComissao() {
      this.pagamentoComissao = { 
        id: 0,
        dataPrevisaoPagamento: this.dataPagamento,
        dataPagamento: this.dataPagamento,
        valorPago: this.comissao.valorEmAberto,
        venda: { id: this.venda.id },
        comissao: { id: this.comissao.id },
        corretor: { 
          id: this.comissao.corretor ? this.comissao.corretor.id : 0, 
          nome: this.comissao.corretor ? this.comissao.corretor.nome : ""
        },
        contaBancaria: { ...this.contaBancaria}
      };

      this.showLoading();

      this.pagarComissaoCompleta(this.pagamentoComissao).then((response) => {
        this.hideLoading();

        switch(response.status) {
          case "SUCESSO":
            this.$message.success(response.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(response.mensagem);
            break;
          case "ERRO":
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },

    reset(){
      this.contaBancaria = {
        id: 0,
        nome: ''
      }
    },

    fechar() {
      this.reset();
      this.$emit("close");
    },
    exibirSelecionarContaBancariaDestinoDialog() {
      this.visibilidadeSelecionarContaBancariaDestinoDialog = true

    },
    
    fecharSelecionarContaBancariaDestinoDialog(contaBancaria) {
      if(contaBancaria && contaBancaria.id !== 0){
        this.contaBancaria = contaBancaria
      }
      this.visibilidadeSelecionarContaBancariaDestinoDialog = false;
    },
  }
};
</script>

